import { useEffect } from 'react';
import { setAttributes } from '@updater/identity';
import { useQual } from 'hooks';
import { toSlotValue } from 'utils/buildOptionalFields';

// Module-level guard so the qual's initial attributes are applied once per
// page load, surviving React Strict Mode remounts and Next.js page
// navigations, which both create a fresh component instance.
let hasSetInitialAttributes = false;

/**
 * Feeds qual-derived attributes into the identity profile. The profile itself
 * already exists: `initIdentity()` runs at module scope in `_app`.
 */
export function IdentityInit() {
  const { promoId, uuid } = useQual();

  // The qual's `uuid` is where a partner's own user id arrives when they send
  // one. Coerced with toSlotValue because the qual is hand-buildable JSON off
  // a URL, so the value can arrive as a number or an object despite its type.
  const partnerUserId = toSlotValue(uuid);

  // Read on first mount only, which is when init() read them before
  // initIdentity() moved init() to app load (COREX-1900).
  useEffect(() => {
    if (hasSetInitialAttributes) return;
    hasSetInitialAttributes = true;
    setAttributes({ promoId, partnerUserId });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (promoId) {
      setAttributes({ promoId });
    }
  }, [promoId]);

  return null;
}
